import { useDraggable } from '@dnd-kit/core'
import { GripVertical } from 'lucide-react'
import { useRef } from 'react'

import type { FormFieldType } from '@/types/enums'

import type { FieldTypeConfig } from './fieldTypeConfig'

export function PaletteDragItem({ cfg, onAdd, draggable = true }: { cfg: FieldTypeConfig; onAdd: (type: FormFieldType) => void; draggable?: boolean }) {
  const { attributes, listeners, setNodeRef, isDragging } = useDraggable({ id: `palette-${cfg.type}`, data: { source: 'palette', fieldType: cfg.type }, disabled: !draggable })
  const dragged = useRef(false)
  if (isDragging) dragged.current = true
  const Icon = cfg.icon
  return (
    <div ref={setNodeRef} {...attributes} {...listeners} onClick={() => { if (dragged.current) { dragged.current = false; return } onAdd(cfg.type) }} title={draggable ? `Click to add, or drag to place: ${cfg.label}` : `Add ${cfg.label}`} className={`flex items-center gap-2.5 rounded-lg border px-3 py-2.5 ${draggable ? 'cursor-grab active:cursor-grabbing' : 'cursor-pointer'} select-none transition-colors duration-150 ${cfg.bg} ${cfg.border} ${isDragging ? 'opacity-40' : 'hover:brightness-[0.98]'}`}>
      <div className="flex h-7 w-7 shrink-0 items-center justify-center rounded-md bg-background/70"><Icon className={`h-4 w-4 ${cfg.iconColor}`} /></div>
      <span className={`text-sm font-medium ${cfg.iconColor}`}>{cfg.label}</span>
      {draggable && <GripVertical aria-hidden="true" className={`ml-auto h-4 w-4 shrink-0 ${cfg.iconColor} opacity-60`} />}
    </div>
  )
}
